import React from 'react';
import styled from 'styled-components';
import Spinner from '@/presentation/components/Spinner';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import Link from '@/presentation/reusables/Link';
import ModuleContainer from '@/presentation/components/Container';
import { Block, Icon } from '@/presentation/components';
import { BackButton } from '../../components';

const ScholarshipsList = styled.div`
  display: grid;
  gap: 24px;
  width: 100%;
  margin-bottom: 24px;
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const ScholarshipCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
`;

const CardHeader = styled.div`
  background: #d5e5f0;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  max-height: 48px;
  object-fit: contain;
`;

const CardBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #161d1f;
  margin-bottom: 4px;
`;

const CardDiscount = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #5b36f2;
`;

const MssgWarning = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
  font-weight: 700;

  > p {
    display: flex;
    align-items: center;

    > span {
      margin-right: 4px;
    }
  }
`;
const HeaderTitle = styled.div`
  width: 100%;
  font-size: 24px;
  font-weight: 700;
  color: #161d1f;
  margin-bottom: 8px;
`;
const HeaderDescription = styled.div`
  width: 100%;
  font-size: 14px;
  color: #161d1f;
  margin-bottom: 8px;
`;
const HeaderWarning = styled.div`
  width: 100%;
  display: block;
  color: #161d1f;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 28px;
`;

const ScholarshipsDiscountsView = ({
  isLoading,
  scholarships,
  handlerRedirectNewPage,
  handleBack
}: any) => (
  <ModuleContainer containerType="section">
    <Block
      customized
      width="100%"
      display="flex"
      justifyContent="flex-start"
      padding="16px 0 0 0"
    >
      <BackButton onClick={handleBack} fontSize="14px" />
    </Block>
    <HeaderTitle>Becas y convenios</HeaderTitle>
    {isLoading ? (
      <Spinner height={80} colorText="#5B36F2" />
    ) : (
      <Block>
        <HeaderDescription>
          Accede a descuentos en tus cuotas a través de nuestras becas y
          convenios con instituciones aliadas.
        </HeaderDescription>
        <HeaderWarning>
          Solo puedes aplicar a una beca o convenio por ciclo.
        </HeaderWarning>

        <ScholarshipsList>
          {scholarships.map((scholarship: any) => (
            <ScholarshipCard
              key={scholarship.id}
              onClick={() => handlerRedirectNewPage(scholarship.redirectUrl)}
            >
              <CardHeader>
                {' '}
                <LogoImage src={scholarship.logoUrl} alt="IconAppGallery" />
              </CardHeader>
              <CardBody>
                <CardInfo>
                  <CardTitle>{scholarship.name}</CardTitle>
                  <CardDiscount>{scholarship.discountText}</CardDiscount>
                </CardInfo>
                {scholarship.isNew && (
                  <span
                    style={{
                      backgroundColor: '#5B36F2',
                      borderRadius: '20px',
                      marginLeft: 'auto',
                      marginRight: '8px',
                      color: '#FFF8F7',
                      fontSize: '12px',
                      fontWeight: '700',
                      padding: '4px 12px'
                    }}
                  >
                    Nuevo
                  </span>
                )}
                <Icon name="chevron-right" size={24} color="#5B36F2" />
              </CardBody>
            </ScholarshipCard>
          ))}
        </ScholarshipsList>

        <Block>
          <WarningMessage
            message={
              <MssgWarning>
                <b>¿No encuentras tu beca o convenio?</b>
                <p>
                  <span>1. Revisa la guía de</span>{' '}
                  <Link
                    linkName="becas y descuentos"
                    linkType="external"
                    url="https://drive.google.com/file/d/1QCoGRROZYmoDveiym1WvQ9V__6PzPgXP/view?usp=drive_link"
                  />
                </p>
                <p>
                  <span>2. Registra tu</span>{' '}
                  <Link
                    linkName="solicitud de SAE"
                    linkType="external"
                    url="/tramites/ticketera/registro?v=TA0034"
                  />
                </p>
              </MssgWarning>
            }
            styledProps={{
              background: '#D5E5F0',
              padding: '16px',
              alignItems: 'flex-start',
              maxWidth: '359px'
            }}
          />
        </Block>
      </Block>
    )}
  </ModuleContainer>
);

export default ScholarshipsDiscountsView;
